import { Component, inject } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

@Component({
  selector: 'app-short-url-redirect',
  templateUrl: './short-url-redirect.component.html',
  styleUrls: ['./short-url-redirect.component.scss'],
  standalone: false,
})
export class ShortUrlRedirectComponent {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  constructor() {
    const id = this.route.snapshot.params.id;
    const inputQueryParams = this.route.snapshot.queryParams;
    const queryParams: Params = Object.assign({ id }, inputQueryParams);
    const root = this.router.url.slice(0, 3);

    switch (root) {
      case '/r/':
        this.router.navigate(['register'], { queryParams });
        break;
      case '/e/':
        this.router.navigate(['challenge', 'enrol'], { queryParams });
        break;
      case '/o/':
        this.router.navigate(['registration'], { queryParams });
        break;
      case '/c/':
        this.router.navigate(['challenge'], { queryParams });
        break;
      default:
        this.router.navigate(['login']);
    }
  }
}
